export const updateUnassignedBookingEndpoint = '/berths/booking/unassign' as const
